import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { useStore } from '@roc/client-portal-shared/hooks';
import { capitalizeOnlyFirstLetter } from "@roc/feature-comp-tool";
import ListIcon from '@material-ui/icons/List';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { ReactComponent as HouseWithPlusIcon } from '../images/housewithplus.svg';

const useStyles = makeStyles((theme) => ({

  button: {
    paddingBlock: "0px !important",
    height: "40px",
  },
  addComparableButton: {
    marginRight: "16px"
  },
  icon: {
    width: "20px",
    height: "20px"
  }
}));

interface ComparablesSectionHeaderProps {
  onAddComparableClick: () => void
}

export const ComparablesSectionHeader = observer(({ onAddComparableClick }: ComparablesSectionHeaderProps) => {

  const { compToolStoreV2: compToolStore } = useStore();

  const propertyAddress = capitalizeOnlyFirstLetter(compToolStore?.subjectProperty?.data.address);

  const { number_of_properties } = compToolStore?.compResponse;

  const size = number_of_properties;

  const classes = useStyles();

  const showListViewButton = compToolStore.showCardView;

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
      <Box display="flex" flexDirection="row" alignItems="center">
        <Typography variant="h6" style={{ fontWeight: "bold" }}>
          {size} Comparable Properties{"\u00A0"}
        </Typography>
        <Typography variant="h6">
          near {propertyAddress}
        </Typography>
      </Box>

      <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center" >
        <Button
          className={`${classes.button} ${classes.addComparableButton}`}
          startIcon={<HouseWithPlusIcon className={classes.icon} />}
          variant="outlined"
          color="primary"
          onClick={() => onAddComparableClick()}
        >
          ADD COMPARABLE
        </Button>
        {showListViewButton ? (
          <Button
            className={classes.button}
            startIcon={<ListIcon />}
            variant="outlined"
            color="primary"
            onClick={() => compToolStore.setShowCardView(false)}>List View</Button>
        )

          :
          (
            <Button
              className={classes.button}
              startIcon={<DashboardIcon />}
              variant="outlined"
              color="primary"
              onClick={() => compToolStore.setShowCardView(true)}>Card View</Button>)
        }
      </Box>


    </Box>)
});